import { State } from "./ReleasePacks.types";

export const DEFAULT_STATE: State = {
  iterations: [],
  selectedIteration: null,
  workItems: [],
  uatWorkItems: [],
  uatCompletedWorkItems: [],
  prdWorkItems: [],
  prdCompletedWorkItems: [],
  isLoading: true,
};

export enum ACTION_KEYS {
  SET_ITERATIONS = "SET_ITERATIONS",
  SET_ITERATIONS_DATA_START_FETCH = "SET_ITERATIONS_DATA_START_FETCH",
  SET_ITERATIONS_DATA_FETCH_ERROR = "SET_ITERATIONS_DATA_FETCH_ERROR",
  SET_ITERATIONS_DATA_FETCH_SUCCESS = "SET_ITERATIONS_DATA_FETCH_SUCCESS",

  SET_ITERATION = "SET_ITERATION",

  SET_WORKITEMS = "SET_WORKITEMS",

  SET_UAT_WORKITEMS = "SET_UAT_WORKITEMS",
  SET_UAT_COMPLETED_WORKITEMS = "SET_UAT_COMPLETED_WORKITEMS",

  SET_PRD_WORKITEMS = "SET_PRD_WORKITEMS",
  SET_PRD_COMPLETED_WORKITEMS = "SET_PRD_COMPLETED_WORKITEMS",
}

type Actions =
  | { type: ACTION_KEYS.SET_ITERATIONS; payload: any }
  | { type: ACTION_KEYS.SET_ITERATIONS_DATA_START_FETCH }
  | { type: ACTION_KEYS.SET_ITERATIONS_DATA_FETCH_ERROR }
  | {
      type: ACTION_KEYS.SET_ITERATIONS_DATA_FETCH_SUCCESS;
      payload: {
        iterations: any[];
      };
    }
  | {
      type: ACTION_KEYS.SET_ITERATION;
      payload: {
        selectedIteration: any;
      };
    }
  | {
      type: ACTION_KEYS.SET_WORKITEMS;
      payload: {
        workItems: any[];
      };
    }
  | {
      type: ACTION_KEYS.SET_UAT_WORKITEMS;
      payload: {
        uatWorkItems: any[];
      };
    }
  | {
      type: ACTION_KEYS.SET_UAT_COMPLETED_WORKITEMS;
      payload: {
        uatCompletedWorkItems: any[];
      };
    }
  | {
      type: ACTION_KEYS.SET_PRD_WORKITEMS;
      payload: {
        prdWorkItems: any[];
      };
    }
  | {
      type: ACTION_KEYS.SET_PRD_COMPLETED_WORKITEMS;
      payload: {
        prdCompletedWorkItems: any[];
        isLoading: boolean;
      };
    };
  
export const releasePacksReducer = (state: State, action: Actions) => {
  switch (action.type) {
    case ACTION_KEYS.SET_ITERATIONS: {
      return { ...state, iterations: action.payload };
    }

    case ACTION_KEYS.SET_ITERATIONS_DATA_START_FETCH: {
      return {
        ...state,
        iterations: {
          ...state.iterations,
        },
        isLoading: true,
        error: "",
      };
    }

    case ACTION_KEYS.SET_ITERATIONS_DATA_FETCH_ERROR: {
      return {
        ...state,
        iterations: {
          ...state.iterations,
        },
        isLoading: false,
        error: "Error occurred during fetching enviroment settings",
      };
    }

    case ACTION_KEYS.SET_ITERATIONS_DATA_FETCH_SUCCESS: {
      return {
        ...state,
        iterations: action.payload.iterations,
        isLoading: false,
      };
    }

    case ACTION_KEYS.SET_ITERATION: {
      return {
        ...state,
        selectedIteration: action.payload,
        isLoading: true
      };
    }

    case ACTION_KEYS.SET_WORKITEMS: {
      return {
        ...state,
        workItems: action.payload.workItems,
      };
    }

    case ACTION_KEYS.SET_UAT_WORKITEMS: {
      return {
        ...state,
        uatWorkItems: action.payload.uatWorkItems,
      };
    }

    case ACTION_KEYS.SET_UAT_COMPLETED_WORKITEMS: {
      return {
        ...state,
        uatCompletedWorkItems: action.payload.uatCompletedWorkItems,
      };
    }

    case ACTION_KEYS.SET_PRD_WORKITEMS: {
      return {
        ...state,
        prdWorkItems: action.payload.prdWorkItems,
      };
    }

    case ACTION_KEYS.SET_PRD_COMPLETED_WORKITEMS: {
      return {
        ...state,
        prdCompletedWorkItems: action.payload.prdCompletedWorkItems,
        isLoading: action.payload.isLoading
      };
    }

    default:
      throw new Error("Such action is not supported");
  }
};
